<template>
    <div id="consonant-table" class="consonant-table" style="--bs-breadcrumb-divider: '>';">
        <h2>{{ langSet[lang || 'en'].learnAlphabets.consonants }} (35)</h2>
        <p class="text-dark" v-html="langSet[lang || 'en'].consonantView.description"></p>

        <div class="mt-4 d-flex flex-wrap justify-content-center">
            <div style="width: 20px; height: 20px;" class="bg-secondary"></div>
            <span class="ms-1">
                = {{ langSet[lang || 'en'].consonantView.zeroConsonants }}
            </span>
            <span class="ms-2">
                <span class="badge rounded-pill text-bg-light text-primary fw-bold">CL</span>
                <span>= {{ langSet[lang || 'en'].consonantView.clearConsonants }}</span>
            </span>
            <span class="ms-2">
                <span class="badge rounded-pill text-bg-light text-danger fw-bold">BT</span>
                <span>= {{ langSet[lang || 'en'].consonantView.breathyConsonants }}</span>
            </span>
        </div>
        <table class="my-2">
            <thead>
                <tr>

                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="bg-light"></td>
                    <td class="bg-light">{{ langSet[lang || 'en'].consonantView.column }} 1</td>
                    <td class="bg-light">{{ langSet[lang || 'en'].consonantView.column }} 2</td>
                    <td class="bg-light">{{ langSet[lang || 'en'].consonantView.column }} 3</td>
                    <td class="bg-light">{{ langSet[lang || 'en'].consonantView.column }} 4</td>
                    <td class="bg-light">{{ langSet[lang || 'en'].consonantView.column }} 5</td>
                </tr>
                <tr v-for="(item, index) in consonants" :key="index">
                    <td :class="item.type === 'none' ? 'bg-secondary' : 'bg-light'">
                        <span class="d-none d-md-inline">{{ index < 5 ? `${langSet[lang || 'en'].consonantView.row}`
                            : '-' }}</span>
                                <span class="fw-bold d-none d-md-block">
                                    {{ lang == 'en' ? item.label : lang == 'th' ? item.label_th : item.label_mnw }}
                                </span>
                    </td>
                    <td v-for="(consonant, cIndex) in item.rows" :key="cIndex">
                        <div class="mb-2">
                            <span class="fs-2">{{ consonant.letter }}</span>
                            <span v-if="consonant.tone == 'clear'"
                                class="d-block d-md-inline text-center ms-2 badge rounded-pill text-bg-light text-primary fw-bold">CL</span>
                            <span v-if="consonant.tone == 'breathy' && !consonant.tone2"
                                class="d-block d-md-inline text-center ms-2 badge rounded-pill text-bg-light text-danger fw-bold">BT</span>
                            <span v-if="consonant.tone == 'breathy' && consonant.tone2 == 'clear'"
                                class="d-block d-md-inline text-center ms-2 badge rounded-pill text-bg-light text-muted fw-bold"><span
                                    class="text-danger">BT</span> • <span class="text-primary">CL</span></span>
                        </div>
                        <div class="mb-1 text-muted">
                            <span class="d-block">{{ `/${consonant.ipa}/` || 'NaN' }}</span>
                            <span class="d-block d-md-inline">{{ `/${consonant.th}/` || 'NaN' }}</span>
                            <strong class="ms-md-1 d-block d-md-inline">({{ consonant.thLetter || 'NaN'
                            }})</strong>
                        </div>
                        <button class="d-none mt-1 btn btn-sm btn-outline-success py-0 px-1"
                            @click="pronouceConsonant(consonant)" disabled>
                            🔊
                            <span class="d-none d-md-inline">
                                {{ langSet[lang || 'en'].menu.listen }}
                            </span>
                        </button>
                        <button v-if="copiedIndex == index && copiedCIndex == cIndex"
                            class="mt-1 ms-0 ms-md-1 btn btn-sm btn-light py-0 px-1 disabled">
                            ✅
                            <span class="d-none d-md-inline">
                                {{ langSet[lang || 'en'].menu.copied }}
                            </span>
                        </button>
                        <button v-else class="mt-1 ms-0 ms-md-1 btn btn-sm btn-outline-secondary py-0 px-1"
                            @click="copyToClipboard(consonant.letter, index, cIndex)">
                            📋
                            <span class="d-none d-md-inline">
                                {{ langSet[lang || 'en'].menu.copy }}
                            </span>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <p>{{ langSet[lang || 'en'].consonantView.note }}</p>
    </div>
</template>

<script>
import monAlphabets from '@/services/mon-library/alphabets/alphabets';

import displayLanguages from '@/assets/data/localizations/display-languages';

export default {
    name: 'CompConsonantTable',
    props: {
        lang: String
    },
    mounted() {
        console.log('con-lang', this.lang)
    },
    data() {
        return {
            langSet: displayLanguages.langSet,
            copiedIndex: null,
            copiedCIndex: null,
            copiedText: '',
            consonants: monAlphabets.consonants.slice(0, 7),
        }
    },
    methods: {
        copyToClipboard(text, index, cIndex) {
            this.copiedIndex = index;
            this.copiedCIndex = cIndex;
            this.copiedText = text;
            navigator.clipboard.writeText(text).then(() => {
                //alert('Copied to clipboard: ' + text);
                setTimeout(() => {
                    this.copiedBtnIndex = null;
                    this.copiedText = '';
                }, 2000); // Clear after 2 seconds
            }).catch(err => {
                console.error('Failed to copy: ', err);
            });
        },
        pronouceConsonant(consonant) {
            console.log(`Pronunciation: ${consonant.ipa}`);
            const audio = new Audio(consonant.sound);
            audio.play().catch(err => {
                console.error('Error playing sound: ', err);
            });
        }
    },
}
</script>

<style scoped>
table {
    width: 100%;
    border-collapse: collapse;
}

th,
td {
    border: 1px solid #ccc;
    padding: 6px;
    text-align: center;
}

th {
    background: #f5f5f5;
}
</style>